export function getBetUniqueId(bet) {
    return `${bet.id}_${bet.handicap}`;
}
